<h2 mat-dialog-title>
  {{ 'igo.geo.style.styleModal' | translate }}
</h2>
<div
  class="edition-drawing"
  mat-dialog-content
  [hidden]="data.features.length === 0"
>
  <form class="igo-form" [formGroup]="form">
    <div class="color-picker">
      @if (linestringOnly !== true) {
        <span>
          <mat-icon class="stroke-palette-icon">format_color_fill</mat-icon>
          {{ 'igo.geo.style.fill' | translate }}
        </span>
        <igo-color-picker-form-field formControlName="fill" />
      }

      <span>
        <mat-icon class="stroke-palette-icon">border_color </mat-icon>
        {{ 'igo.geo.style.stroke' | translate }}
      </span>

      <igo-color-picker-form-field formControlName="stroke" />
    </div>

    <div class="igo-input-container">
      <mat-form-field class="igo-form-input-box" subscriptSizing="dynamic">
        <mat-label>{{ 'igo.geo.style.fontSize' | translate }}</mat-label>
        <input
          matInput
          #testFontSize
          type="number"
          placeholder="10"
          min="10"
          onkeydown="return event.keyCode !== 69"
          [value]="getFeatureFontSize()"
          (input)="styleModalData.fontSize = $any($event.target).value"
        />
        <span matTextSuffix>px</span>
      </mat-form-field>
      <mat-form-field class="igo-form-input-box" subscriptSizing="dynamic">
        <mat-label>{{ 'igo.geo.style.fontStyle' | translate }}</mat-label>
        <mat-select
          #testFontStyle
          [value]="getFeatureFontStyle()"
          (selectionChange)="styleModalData.fontStyle = $event.value"
        >
          @for (fontSelect of allFontStyles; track fontSelect) {
            <mat-option [value]="fontSelect">
              {{ fontSelect }}
            </mat-option>
          }
        </mat-select>
      </mat-form-field>
      <mat-form-field class="igo-form-input-box" subscriptSizing="dynamic">
        <mat-label>{{ 'igo.geo.style.offsetX' | translate }}</mat-label>
        <input
          matInput
          #offsetXInput
          type="number"
          onkeydown="return event.keyCode !== 69"
          [value]="getFeatureOffsetX()"
          (input)="styleModalData.offsetX = $any($event.target).value"
        />
      </mat-form-field>
      <mat-form-field class="igo-form-input-box" subscriptSizing="dynamic">
        <mat-label>{{ 'igo.geo.style.offsetY' | translate }}</mat-label>
        <input
          matInput
          #offsetYInput
          type="number"
          onkeydown="return event.keyCode !== 69"
          [value]="getFeatureOffsetY()"
          (input)="styleModalData.offsetY = $any($event.target).value"
        />
      </mat-form-field>
    </div>
  </form>
</div>
<div mat-dialog-actions>
  <button matButton="elevated" (click)="cancelDrawing()">
    {{ 'igo.geo.style.cancel' | translate }}
  </button>
  <button matButton="elevated" color="primary" (click)="confirm()">OK</button>
</div>
